import renderMaskedInput from 'components/FormControls/maskedInputField'
import renderInputField from 'components/FormControls/textInput'
import PropTypes from 'prop-types'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Field } from 'redux-form'
import phoneMask from 'utils/constants/phoneMask'
import phoneFieldNormalize from 'utils/normalize/phoneFieldNormalize'
import { onlyNumbers } from 'utils/normalize/onlyNumbers'

const JuridicalForeign = () => {
  const { t } = useTranslation()

  return (
    <>
      <div className={'margin-bottom-16'}>
        <Field
          fullWidth
          name="details.company_registration_number"
          component={renderInputField}
          label={t('payment_profiles::new.fields.details.company_registration_number.label')}
          normalize={onlyNumbers}
          t={t}
        />
      </div>

      <div className={'margin-bottom-16'}>
        <Field
          fullWidth
          name="details.beneficiary_name"
          component={renderInputField}
          label={t('payment_profiles::new.fields.details.beneficiary_name.label')}
          t={t}
        />
      </div>

      <div className={'margin-bottom-16'}>
        <Field
          fullWidth
          normalize={phoneFieldNormalize}
          name="details.phone"
          component={renderMaskedInput}
          placeholderChar={'\u2002'}
          placeholder={'+ ( )'}
          mask={phoneMask}
          label={t('payment_profiles::new.fields.details.phone.label')}
          t={t}
        />
      </div>

      <div className={'margin-bottom-16'}>
        <Field
          name="details.contact_email"
          type="email"
          fullWidth
          component={renderInputField}
          label={t('payment_profiles::new.fields.details.contact_email.label')}
          t={t}
        />
      </div>

      <div className={'margin-bottom-16'}>
        <Field
          fullWidth
          name="details.registration_address"
          component={renderInputField}
          label={t('payment_profiles::new.fields.details.registration_address.label')}
          t={t}
        />
      </div>

      <div className={'margin-bottom-16'}>
        <Field
          fullWidth
          name="details.bank_address"
          component={renderInputField}
          label={t('payment_profiles::new.fields.details.bank_address.label')}
          t={t}
        />
      </div>

      <div className={'margin-bottom-16'}>
        <Field
          fullWidth
          name="details.bank_account_number"
          component={renderInputField}
          label={t('payment_profiles::new.fields.details.bank_account_number.label')}
          normalize={onlyNumbers}
          t={t}
        />
      </div>

      <div className={'margin-bottom-16'}>
        <Field
          fullWidth
          name="details.iban"
          component={renderInputField}
          label={t('payment_profiles::new.fields.details.iban.label')}
          normalize={onlyNumbers}
          t={t}
        />
      </div>

      <div className={'margin-bottom-16'}>
        <Field
          fullWidth
          name="details.swift"
          component={renderInputField}
          label={t('payment_profiles::new.fields.details.swift.label')}
          normalize={onlyNumbers}
          t={t}
        />
      </div>
    </>
  )
}

JuridicalForeign.propTypes = {
  details: PropTypes.object,
  form: PropTypes.string,
}

export default JuridicalForeign
